import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  ListMyBids_homework_listMyBids_bids as Bids,
  ListMyBids,
} from '../../athena/types/ListMyBids';
import { BidFields } from '../../fragments/homework/Bid';

export const LIST_MY_BIDS = gql`
  query ListMyBids {
    homework {
      listMyBids {
        bids {
          ...BidFields
        }
      }
    }
  }
  ${BidFields}
`;

export default buildQueryHook<ListMyBids, Record<string, never>, Bids[] | null>(LIST_MY_BIDS, {
  wrangler: (data) => data?.homework?.listMyBids?.bids || null,
});
